<template>
  <div
    class="pl-form-input-group"
    :class="[{'pl-form-input-group_textarea': textareaInput}, {'invalid-group': !isValid || !wrongPhone || !wrongEmail }, groupClass]"
  >
    <label :for="id" class="pl-form-label" v-if="label" :class="labelClass">
      {{label}}
      <span v-if="required">*</span>
    </label>
    <template v-if="!textareaInput">
      <input
        :type="type"
        :name="id"
        :id="id"
        :min="type == 'number' ? 0 : null"
        class="pl-form-input"
        :class="[{'alert-border': !isValid || !wrongPhone || !wrongEmail }, { uneditable: uneditable }, inputClass]"
        :disabled="uneditable"
        :required="required"
        :placeholder="placeholder"
        :value="value"
        @change="onInput($event)"
        @focus="onFocus"
        @keypress="onKeypress($event)"
      />
    </template>
    <template v-if="textareaInput">
      <textarea
        :name="id"
        :id="id"
        class="pl-form-input pl-form-input__textarea"
        :class="[{'alert-border': !isValid }, { uneditable: uneditable }, inputClass]"
        :required="required"
        :rows="textareaRows"
        :style="{'height': textareaHeight}"
        :value="value"
        @change="onInput($event)"
        @focus="onFocus"
        @keypress="onKeypress($event)"
      ></textarea>
    </template>
    <div style="min-height: 18px">
      <div class="pl-form-validation" style="height: auto; min-height: 0">
          <span v-if="!isValid">{{validationMessage ? validationMessage : 'This is a required field'}}</span>
          <span v-if="!wrongPhone">Phone number must be 11 digits and start with a 0</span>
          <span v-if="!wrongEmail">Incorrect email format</span>
        </div>
  
      <div class="pl-form-privacy" v-if="privacy">
        <span v-if="isValid">
          <template v-if="!formInfo">
            (by providing this number you are consenting
            to us contacting you by text if necessary)
          </template>
          <template v-if="formInfo">
            <span v-html="formInfo"></span>
          </template>
        </span>
      </div>
      <div class="pl-form-additional-info" v-if="!privacy && formInfo">
        <template v-if="isValid">
          <span v-html="formInfo"></span>
        </template>
      </div>
      <div class="pl-form-additional-info" v-if="!privacy && fieldInfo">
          <span v-html="fieldInfo"></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "input-group",
  props: {
    id: String,
    type: String,
    label: String,
    required: Boolean,
    placeholder: String,
    inputClass: String,
    groupClass: String,
    labelClass: String,
    validator: Boolean,
    emailValidator: Boolean,
    phoneValidator: Boolean,
    numberInput: Boolean,
    privacy: Boolean,
    textareaInput: Boolean,
    textareaRows: Number,
    textareaHeight: String,
    formInfo: String,
    fieldInfo: String,
    value: String,
    uneditable: Boolean,
    validationMessage: String
  },
  data() {
    return {
      isValid: true,
      wrongPhone: true,
      wrongEmail: true
    };
  },
  watch: {
    validator: function() {
      this.isValid = !this.validator;
    },
    emailValidator: function() {
      this.wrongEmail = !this.emailValidator;
    },
    phoneValidator: function() {
      this.wrongPhone = !this.phoneValidator;
    }
  },
  methods: {
    onKeypress(event) {
      if (event.target.id == "phone" || this.numberInput) {
        event = event || window.event;
        if (
          event.charCode &&
          event.charCode != 0 &&
          (event.charCode < 48 || event.charCode > 57)
        ) {
          event.preventDefault();
        }
      }
    },
    onInput(event) {
      let emitValue = {};
      emitValue.name = event.target.id;
      emitValue.value = event.target.value;
      this.$emit("input", emitValue);
    },
    onFocus(event) {
      this.$emit("focus", event.target.id);
    }
  }
};
</script>
